<div class="mat-typography">
  <h2 mat-dialog-title>
    <b
      ><span fxFlex class="primary-color">{{ data.dialogTitle }}</span></b
    >
  </h2>
  <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 0px;"></div>
  <div mat-dialog-content class="scrollable" style="margin-top: 16px; margin-bottom: 16px; margin-left: 2px; margin-right: 2px;">
    <div *ngIf="showSpinner">
      <p style="text-align: center"><mat-spinner color="accent" diameter="36"></mat-spinner></p>
    </div>
    <div *ngIf="!showSpinner">
      <!-- Title and Title Error -->
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing highlighted-display-text"
        *ngIf="!showError && data.autoPaymentDetail.isAutoPaymentSetup"
      >
        <b
          ><span i18n="@@payment-automatic-confirmation-dialog.form.setup.title"
            >payment-automatic-confirmation-dialog.form.setup.title</span
          ></b
        >
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing warning-color"
        *ngIf="showError && data.autoPaymentDetail.isAutoPaymentSetup"
      >
        <b
          ><span i18n="@@payment-automatic-confirmation-dialog.form.setup.error-title"
            >payment-automatic-confirmation-dialog.form.setup.error-title</span
          ></b
        >
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing highlighted-display-text"
        *ngIf="!showError && data.autoPaymentDetail.isAutoPaymentCancel"
      >
        <b
          ><span i18n="@@payment-automatic-confirmation-dialog.form.cancel.title"
            >payment-automatic-confirmation-dialog.cancel.title</span
          ></b
        >
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing warning-color"
        *ngIf="showError && data.autoPaymentDetail.isAutoPaymentCancel"
      >
        <b
          ><span i18n="@@payment-automatic-confirmation-dialog.form.cancel.error-title"
            >payment-automatic-confirmation-dialog.form.cancel.error-title</span
          ></b
        >
      </div>
      <!-- response form -->
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-automatic-confirmation-dialog.form.payment-type.label"
            placeholder="payment-automatic-confirmation-dialog.form.payment-type.label"
            type="text"
            [value]="_braintreeService.getPaymentTypeDescription(data.autoPaymentDetail.paymentType, data.autoPaymentDetail.creditCardType)"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-automatic-confirmation-dialog.form.name.label"
            placeholder="payment-automatic-confirmation-dialog.form.name.label"
            type="text"
            [value]="data.autoPaymentDetail.name"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-automatic-confirmation-dialog.form.address-line-1.label"
            placeholder="payment-automatic-confirmation-dialog.form.address-line-1.label"
            type="text"
            [value]="data.autoPaymentDetail.addressLine1"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-automatic-confirmation-dialog.form.address-line-2.label"
            placeholder="payment-automatic-confirmation-dialog.form.address-line-2.label"
            type="text"
            [value]="data.autoPaymentDetail.addressLine2"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-automatic-confirmation-dialog.form.city.label"
            placeholder="payment-automatic-confirmation-dialog.form.city.label"
            type="text"
            [value]="data.autoPaymentDetail.city"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-automatic-confirmation-dialog.form.state.label"
            placeholder="payment-automatic-confirmation-dialog.form.state.label"
            type="text"
            [value]="data.autoPaymentDetail.state"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-automatic-confirmation-dialog.form.zip-code.label"
            placeholder="payment-automatic-confirmation-dialog.form.zip-code.label"
            type="text"
            [value]="data.autoPaymentDetail.zipCode"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="
          !showError && data.autoPaymentDetail.paymentType === paymentType.ElectronicCheck && data.autoPaymentDetail.isAutoPaymentSetup
        "
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-automatic-confirmation-dialog.form.confirmation-number.label"
            placeholder="payment-automatic-confirmation-dialog.form.confirmation-number.label"
            type="text"
            [value]="data.autoPaymentDetail.confirmationCode"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing"
        *ngIf="!showError && data.autoPaymentDetail.isAutoPaymentSetup"
      >
        <b
          ><span i18n="@@payment-automatic-confirmation-dialog.form.setup.notice.1"
            >payment-automatic-confirmation-dialog.form.setup.notice.1</span
          >&nbsp;{{ data.autoPaymentDetail.firstPaymentAmount | currency }}&nbsp;<span
            i18n="@@payment-automatic-confirmation-dialog.form.setup.notice.2"
            >payment-automatic-confirmation-dialog.form.setup.notice.2</span
          >&nbsp;{{ data.autoPaymentDetail.firstPaymentDate | date: 'MM/dd/yyyy' }}.</b
        >
      </div>

      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing"
        *ngIf="!showError && data.autoPaymentDetail.isAutoPaymentCancel"
      >
        <b
          ><span i18n="@@payment-automatic-confirmation-dialog.form.cancel.notice.1"
            >payment-automatic-confirmation-dialog.form.cancel.notice.1</span
          >&nbsp;{{ data.autoPaymentDetail.firstPaymentAmount | currency }}&nbsp;<span
            i18n="@@payment-automatic-confirmation-dialog.form.cancel.notice.2"
            >payment-automatic-confirmation-dialog.form.cancel.notice.2</span
          ></b
        >
      </div>

      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing warning-color "
        *ngIf="showError && data.autoPaymentDetail.isAutoPaymentSetup"
      >
        <b><span i18n="@@payment-automatic-confirmation-dialog.setup.error.1">payment-automatic-confirmation-dialog.setup.error.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing warning-color "
        *ngIf="showError && data.autoPaymentDetail.isAutoPaymentSetup"
      >
        <b><span i18n="@@payment-automatic-confirmation-dialog.setup.error.2">payment-automatic-confirmation-dialog.setup.error.2</span></b>
      </div>

      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing warning-color "
        *ngIf="showError && data.autoPaymentDetail.isAutoPaymentCancel"
      >
        <b
          ><span i18n="@@payment-automatic-confirmation-dialog.cancel.error.1"
            >payment-automatic-confirmation-dialog.cancel.error.1</span
          ></b
        >
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing warning-color "
        *ngIf="showError && data.autoPaymentDetail.isAutoPaymentCancel"
      >
        <b
          ><span i18n="@@payment-automatic-confirmation-dialog.cancel.error.2"
            >payment-automatic-confirmation-dialog.cancel.error.2</span
          ></b
        >
      </div>
      <div fxLayout="row" class="display-text normal-paragraph-spacing" *ngIf="isMobileDevice()">
        <span class="flex-spacer"></span>
        <button
          mat-flat-button
          color="primary"
          (click)="onCloseClick()"
          *ngIf="!showSpinner"
          i18n="@@payment-automatic-confirmation-dialog.close-button.label"
        >
          payment-automatic-confirmation-dialog.close-button.label
        </button>
      </div>
      <div fxLayout="row" class="display-text large-paragraph-spacing" *ngIf="isMobileDevice()">
        &nbsp;
      </div>
      <div fxLayout="row" class="display-text large-paragraph-spacing" *ngIf="isMobileDevice()">
        &nbsp;
      </div>
    </div>
  </div>
  <div mat-dialog-actions *ngIf="!isMobileDevice()">
    <span class="flex-spacer"></span>
    <button
      mat-flat-button
      color="primary"
      (click)="onCloseClick()"
      *ngIf="!showSpinner"
      i18n="@@payment-automatic-confirmation-dialog.close-button.label"
    >
      payment-automatic-confirmation-dialog.close-button.label
    </button>
  </div>
</div>
